export const FETCH_SERVICE_ENDPOINTS = {
  START: 'FETCH_SERVICE_ENDPOINTS_START',
  SUCCESS: 'FETCH_SERVICE_ENDPOINTS_SUCCESS',
  ERROR: 'FETCH_SERVICE_ENDPOINTS_ERROR',
};
